export const learningPathEditMessages = {
  exporting: 'The export is being downloaded.',
};
